import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";

// Le site M&D est servi statiquement depuis /public/.
// React reste branché par sécurité (build CRA) mais ne fait rien si #root absent.
const mount = document.getElementById("root");
if (mount) {
  ReactDOM.createRoot(mount).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
